import { Form, FormItemProps, Select } from 'antd';

import { Option } from '../../../types';
import { TicketStatusTitle } from '../../../store/ticket';

const options: Option[] = Object.entries(TicketStatusTitle).map(([key, value]) => ({ label: value, value: key }));

// eslint-disable-next-line import/prefer-default-export
export function SelectTicketStatus({ ...props }: FormItemProps) {
  return (
    <Form.Item label="Ticket Status" name="status" {...props}>
      <Select style={{ width: '100%' }} placeholder="Ticket Status" options={options} allowClear />
    </Form.Item>
  );
}
